module.exports = __webpack_public_path__ + "media/images/person1-0322149c6c69953641657dd3e59112c1.png";